





































































import { Prop, Component, Vue, Watch } from 'vue-property-decorator'
import { v4 } from 'uuid'

export interface InputSubSelectOption {
    label: string
    value: string
    optionsHeader?: string
    options?: InputSubSelectOption[]
    classList?: string
    disabled?: boolean
    clickable?: boolean
}

@Component
export default class InputSubSelect extends Vue {
    @Prop({ type: Boolean, default: true}) readonly isRoot!: boolean
    @Prop({ type: Boolean, default: false}) readonly loading!: boolean
    @Prop({ type: String, default: ''}) readonly loadingLabel!: string
    @Prop({ type: String, default: ''}) readonly savedLabel!: string
    @Prop({ type: Boolean, default: false}) readonly hideLabel!: boolean
    @Prop({ type: Boolean, default: false}) readonly disabled!: boolean
    @Prop({ type: Boolean, default: false}) readonly hideActiveHighlight!: boolean
    @Prop({ type: Boolean, default: false}) readonly labelAsHeader!: boolean
    @Prop({ type: String, required: true}) readonly label!: string
    @Prop({ type: String, default: ''}) readonly description!: string
    @Prop({ type: Array, default() { return [] }}) readonly actualValue!: any[]
    @Prop({ type: Array, default() { return [] }}) readonly selectedLabel!: any[]
    @Prop({ type: Array, default() { return [] }}) readonly options!: InputSubSelectOption[]
    @Prop() readonly value!: any
    @Prop({ default() { return [] } }) readonly parentValue!: any[]
    @Prop({ type: String, default: 'white' }) readonly color: string
    @Prop({ type: String, default: null }) readonly optionsHeader: string
    @Prop({ type: Boolean, default: true }) readonly clickable: boolean

    uuid = v4()
    saved = false
    savedTimeout = null
    collapsed = false
    rootValue = []
    collapseTimeout = null

    mounted() {
        this.setActualValue()
    }

    mouseOver(event) {
        this.$emit('mouseover', event)

        if (this.isRoot) {
            clearTimeout(this.collapseTimeout)
            this.collapseTimeout = null
        }
    }

    mouseLeave(event) {
        if (this.isRoot) {
            this.collapseTimeout = setTimeout(() => {
                this.collapsed = false
            }, 500)
        }
    }

    toggle() {
        if (this.disabled) {
            return
        }

        this.collapsed = !this.collapsed
    }

    emitValue() {
        if (!this.clickable) {
            return
        }

        this.$emit('subselect-click', this.combinedValue)

        if (this.isRoot) {
            this.collapsed = false
        }
    }

    emitChildValue(childValue: any[]) {
        this.$emit('subselect-click', childValue)

        if (this.isRoot) {
            this.rootValue = childValue
            this.collapsed = false
        }
    }

    @Watch('actualValue')
    setActualValue() {
        if (this.actualValue.length <= 0) {
            this.rootValue = this.value
        } else {
            this.rootValue = this.actualValue
        }
    }

    @Watch('loading')
    watchLoading() {
        if (this.loading) {
            return
        }

        this.saved = true

        this.savedTimeout = setTimeout(() => {
            this.saved = false
            clearTimeout(this.savedTimeout)
            this.savedTimeout = null
        }, 2000)
    }

    get showLabel() {
        let options = this.options
        let option = null

        const labelOptions = []

        if (!options || options.length <= 0) {
            return ''
        }

        for (let i = 0; i < this.rootValue.length; i++) {
            if (this.selectedLabel.length === i) {
                continue
            }

            option = options.find(optionValue => optionValue.value === this.selectedLabel[i])

            if (option) {
                labelOptions.push(option.label)
                options = option.options
            }
        }

        return labelOptions.join(' - ')
    }

    get combinedValue(): any[] {
        if (this.isRoot) {
            return []
        }

        if (this.parentValue.length <= 0) {
            return [this.value]
        }

        return [...this.parentValue, this.value]
    }

    get componentClass() {
        if (this.isRoot) {
            return {
                'input-sub-select': true,
                'input-sub-select--hide-label': this.hideLabel,
                'input-sub-select--hide-active-highlight': this.hideActiveHighlight,
                ['input-sub-select--' + this.color]: true,
                'input-sub-select--open': this.collapsed,
                'input-sub-select--disabled': this.disabled,
            }
        } else {
            return {
                'input-sub-select__item': true,
                'input-sub-select__item--active': this.currentIsSelected,
                'input-sub-select__item--child-active': this.hasSelectedChild,
                'input-sub-select__item--has-children': this.options.length > 0,
            }
        }
    }

    get currentIsSelected() {
        return JSON.stringify([...this.actualValue]) === JSON.stringify([...this.combinedValue])
    }

    get hasSelectedChild() {
        return [...this.actualValue].slice(0, -1).includes(this.value)
    }

    get hasActionLabel() {
        return (this.loadingLabel || this.savedLabel)
    }

    get longestActionLabel() {
        return this.loadingLabel.length > this.savedLabel.length ? this.loadingLabel : this.savedLabel
    }
}
